import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';

import { UsersService } from '@app/services/settings/users.service';
import { SettingsUserSeatStatus } from '@app/store/state/settings/users/users.state';
import { AppService } from '@app/services/app/app.service';

import { HttpStatus } from '@core/classes/http-status.class';

import { SeatSetting } from '@core/objects/seat';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

@Component({
    selector: 'settings-users-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsUsersMainComponent implements OnInit, OnDestroy{

	public access:boolean = true;

	// Subscription status and seats data
	public subscriptionStatusSeats: Subscription;
	public subscriptionSeats: Subscription;
	public subscriptionSession: Subscription;

	// HTTPSTATUS
	public statusSeats: HttpStatus;
	public httpStatusAdd: HttpStatus;

	public loadingSeats: boolean = true;
	public seats: Array<SeatSetting> = [];

	// invitations control
	private freeSeats = false;
	private saml2 = false;

	public breadcrumbs: any = [
			{
					title: "System Settings",
					link: ['/settings']
			}
	];

	public menu: Array<ThreeDotsMenuItem> = [];

	protected menuInvitation: ThreeDotsMenuItem ={
			title: "Invite user",
			key: "invite-user",
			icon: "invite",
			order: 1
	};

	constructor(public userSrv: UsersService, private router: Router, private app: AppService){}

	ngOnInit(){
		this.userSrv.loadAllSeats(); // bring all users and invitations depending on status

		this.subscriptionStatusSeats = this.userSrv.selectorStatusSeatsList().subscribe((statusSeats: HttpStatus) => {
			this.statusSeats = statusSeats;
			if (this.statusSeats.code != HttpStatus.PENDING) {
							this.loadingSeats = false;
			}
			switch (this.statusSeats.message){
				case "403":
					return this.access = false;
			};
		});

		this.subscriptionSeats = this.userSrv.selectorGetAllSeats().subscribe((seats: SeatSetting[]) => {
			this.seats = seats;
			if(seats != null ){
				let total = 0;

				this.seats.forEach(seat => total = total + ( seat.status == SettingsUserSeatStatus.USER_SEAT_FREE ? 1 : 0 ));
				this.freeSeats = (total > 0? true: false);
				this.initView();

			}
		});

		this.subscriptionSession = this.app.getSession().subscribe( (session: any) => {
			// check if saml2 is set to true to avoid let invite userd in users manager screen
			if(session != null){
				this.saml2 = session.options?.organization?.saml2;
				this.initView();
			}
		});
	}

	ngOnDestroy(): void {
		this.subscriptionStatusSeats.unsubscribe();
		this.subscriptionSeats.unsubscribe();
		this.subscriptionSession.unsubscribe();
	}

	initView(){
		if(this.freeSeats && !this.saml2){
				// update 3 dot menu adding or quit item when total seats available.
				// TODO april 2023: review if account is "normal" or is azure user based account.
				this.updateMenu(this.menuInvitation, true);
		}
	}

	tryAgain(event){
			this.loadingSeats = true;
			this.userSrv.loadAllSeats();
	}

	onMenuClick(key: string) {
		switch(key) {
				case "invite-user":
						this.router.navigate(['/settings/users/add']);
						break;
		}
	}

	// this function check either remove or add item. based on subscribed events
	protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
		this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
		if(addItem){
				this.menu.push(item);
		}
	}
}
